export default "__VITE_ASSET__CsDpHhwK__"